/*
 * @Author       : dengjianjun
 * @Date         : 2021-11-15 21:02:57
 * @LastEditors  : Please set LastEditors
 * @LastEditTime : 2022-01-04 16:15:32
 * @Description  : 
 * @FilePath     : /es-template/src/store/modules/common/index.js
 */
/**
 * @description: 
 * @param {*}
 * @return {*}
 */
import { createStore, mpx } from '@didi/es-mpx-creator'

import actions from './action'
import getters from './getter'
import mutations from './mutation'
import state from './state'

const commonStore = createStore({
  state,
  getters,
  mutations,
  actions
})

const mapKey = target => Object.keys(target).forEach(key => mpx.setStorageSync(key, target[key]));

commonStore.subscribe(function({ type, payload }, state) {
  mapKey.apply(null, payload)
})

export default commonStore
